<template>
  <div class="intro">
    <VideoPlayer class="intro__video" :video="video"></VideoPlayer>
    <div class="intro__text">
      <div
        class="intro__text__line"
        v-for="(line, index) in lineArray"
        :key="index"
      >
        <span class="intro__text__line__dot"></span
        ><span class="intro__text__line__value">{{ line }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import VideoPlayer from "../../VideoPlayer";
export default {
  props: {
    lineArray: {
      type: Array,
      default: function() {
        return [];
      }
    },
    video: {
      type: String,
      default: ""
    }
  },
  components: {
    VideoPlayer
  }
};
</script>
<style lang="scss" scoped>
.intro {
  &__video {
    width: 570px;
    height: 338px;
    margin-left: 36px;
    float: right;
  }
  &__text {
    margin-bottom: 63px;
    &__line {
      font-size: 22px;
      font-weight: 300;
      color: rgba(46, 41, 37, 1);
      line-height: 32px;
      &__dot {
        width: 8px;
        height: 8px;
        border-radius: 8px;
        float: left;
        margin-top: 12px;
        background-color: #dadada;
      }
      &__value {
        display: block;
        margin-left: 26px;
        overflow: hidden;
      }
    }
  }
  .intro__text__line:not(:first-child) {
    margin-top: 30px;
  }
}
</style>